import styled from 'styled-components';

const FAQSectionStyle = styled.section`
	--descriptionBlockWidth: 80%;
	--itemTitlePadding: var(--sp3x) var(--sp4x);

	.description-block {
		width: var(--descriptionBlockWidth);
		margin-top: var(--customDistance4);
		opacity: 0;
		transition: var(--trTime) ease-in calc(var(--trTime) * 1.5);

		.description2 {
			margin-top: var(--sp1x);
		}
	}

	.btn {
		opacity: 0;
		transition: var(--trTime) ease-in calc(var(--trTime) * 1.5);
	}

	.left-inner-block {
		.btn {
			margin-top: var(--customDistance4);
		}
	}

	.outside-wrap-collapse-item {
		transform: translateY(100%);
		opacity: 0;
		transition: var(--trTime) ease-out calc((var(--itemDelay) + 3) * 0.2s);

		&:not(:first-child) {
			margin-top: var(--customDistance6);
		}
	}

	.title-block {
		display: flex;
		gap: var(--sp2x);
		justify-content: space-between;

		.icon-container {
			--iconSize: var(--p2);

			transform: rotate(90deg);
			transition: transform var(--trTime) ease-out;
		}
	}

	.item-description {
		padding-top: var(--sp1x);
	}

	#collapse-item {
		border-radius: var(--sp1-5x);
		border: 1px solid var(--textPrimaryColor);
		padding: var(--itemTitlePadding);

		&.active {
			.icon-container {
				transform: rotate(-90deg);
			}
		}
	}

	&.active {
		.description-block,
		.btn {
			opacity: 1;
		}
		.outside-wrap-collapse-item {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			#collapse-item {
				&:hover {
					.icon-container {
						transform: rotate(-90deg);
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--itemTitlePadding: var(--sp2x) var(--sp2-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--itemTitlePadding: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--descriptionBlockWidth: 100%;

		.left-inner-block {
			.btn {
				margin-left: auto;
			}
		}

		.right-block {
			margin-top: var(--customDistance2);
		}
	}
`;

export default FAQSectionStyle;
